import React, { useEffect, useState } from 'react';
import { trackPageView } from '../services/analyticsService';

const AboutUs: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // SEO Meta Tags
  useEffect(() => {
    try {
      document.title = 'About Us - Cheapest Car Recovery in UK & Birmingham | Professional Recovery Team';

      const metaTags = [
        { name: 'description', content: 'About Cheapest Car Recovery in UK & Birmingham - Professional 24/7 breakdown recovery team. Cheap car recovery in UK with years of experience across England, Scotland, Wales & Northern Ireland. Learn about our professional recovery services.' },
        { name: 'keywords', content: 'cheapest car recovery in uk, cheapest car recovery in birmingham, cheap car recovery in uk, about car recovery uk, breakdown recovery company, vehicle recovery services, professional recovery team, roadside assistance uk, car recovery birmingham, emergency recovery uk' },
        { name: 'author', content: 'Cheapest Car Recovery UK' },
        { name: 'robots', content: 'index, follow' },
        { property: 'og:title', content: 'About Us - Cheapest Car Recovery in UK & Birmingham | Professional Recovery Team' },
        { property: 'og:description', content: 'About Cheapest Car Recovery in UK & Birmingham - Professional breakdown recovery team with years of experience. Cheap car recovery in UK across England, Scotland, Wales & Northern Ireland.' },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: 'https://cheapestcarrecovery.uk/about-us' },
        { property: 'og:image', content: 'https://cheapestcarrecovery.uk/my-logo.png' },
        { property: 'og:locale', content: 'en_GB' }
      ];

      metaTags.forEach(tag => {
        const existingTag = document.querySelector(`meta[name="${tag.name}"], meta[property="${tag.property}"]`);
        if (existingTag) {
          existingTag.remove();
        }

        const metaTag = document.createElement('meta');
        if (tag.name) metaTag.setAttribute('name', tag.name);
        if (tag.property) metaTag.setAttribute('property', tag.property);
        metaTag.setAttribute('content', tag.content);
        document.head.appendChild(metaTag);
      });

      trackPageView('/about-us');

    } catch (err) {
      console.error('Error setting SEO meta tags:', err);
    }
  }, []);

  const responsiveStyles = `
    .hover-lift {
      transition: all 0.3s ease;
    }
    
    .hover-lift:hover {
      transform: translateY(-5px);
      box-shadow: 0 15px 35px rgba(0,0,0,0.2);
    }
    
    .gradient-text {
      background: linear-gradient(45deg, #FFF222, #FFD700);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
    
    .section-image {
      position: relative;
      overflow: hidden;
      border-radius: 20px;
    }
    
    .section-image::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(45deg, rgba(255,242,34,0.1), transparent);
      z-index: 1;
    }
    
    .mobile-stack {
      display: flex;
      flex-direction: column;
      gap: 25px;
    }
    
    .mobile-reverse {
      flex-direction: column-reverse;
    }
    
    /* Mobile First Approach */
    @media (max-width: 768px) {
      .hero-content {
        flex-direction: column !important;
        text-align: center !important;
        gap: 30px;
      }
      
      .hero-text {
        padding-right: 0 !important;
        order: 2;
      }
      
      .hero-image {
        order: 1;
        margin-bottom: 0 !important;
      }
      
      .hero-title {
        font-size: 32px !important;
        line-height: 1.2 !important;
      }
      
      .hero-subtitle {
        font-size: 14px !important;
      }
      
      .hero-buttons {
        flex-direction: column !important;
        align-items: center !important;
        gap: 15px !important;
      }
      
      .section-flex {
        flex-direction: column !important;
        gap: 30px !important;
      }
      
      .section-text, .section-image {
        padding: 0 !important;
        width: 100% !important;
      }
      
      .coverage-grid {
        grid-template-columns: 1fr !important;
        gap: 20px !important;
      }
      
      .values-grid {
        grid-template-columns: 1fr !important;
        gap: 20px !important;
      }
      
      .header-nav {
        display: none !important;
      }
      
      .mobile-menu-icon {
        display: block !important;
      }
      
      .header-title {
        font-size: 12px !important;
        line-height: 1.2;
      }
      
      .mobile-menu {
        display: none;
        position: fixed;
        top: 70px;
        left: 0;
        right: 0;
        background: white;
        box-shadow: 0 4px 20px rgba(0,0,0,0.15);
        z-index: 1001;
        padding: 20px;
        transform: translateY(-100%);
        transition: transform 0.3s ease;
      }
      
      .mobile-menu.open {
        display: block;
        transform: translateY(0);
      }
      
      .desktop-get-quote {
        display: none !important;
      }
      
      .mobile-cta-flex {
        flex-direction: column !important;
        gap: 15px !important;
      }
      
      .mobile-features {
        grid-template-columns: repeat(2, 1fr) !important;
        gap: 20px !important;
      }
      
      .section-padding {
        padding: 50px 15px !important;
      }
      
      .large-section-title {
        font-size: 28px !important;
      }
      
      .large-section-text {
        font-size: 16px !important;
      }
    }
    
    @media (max-width: 480px) {
      .hero-title {
        font-size: 26px !important;
      }
      
      .section-title {
        font-size: 24px !important;
      }
      
      .header-title {
        font-size: 12px !important;
      }
      
      .mobile-features {
        grid-template-columns: 1fr !important;
      }
      
      .hero-buttons-mobile {
        padding: 15px 25px !important;
        font-size: 16px !important;
      }
      
      .section-padding {
        padding: 40px 10px !important;
      }
    }
    
    @media (min-width: 769px) {
      .desktop-flex {
        flex-direction: row !important;
        align-items: center !important;
      }
      
      .desktop-text {
        flex: 1;
        padding-right: 40px !important;
      }
      
      .desktop-image {
        flex: 1;
      }
      
      .desktop-reverse .desktop-text {
        padding-right: 0 !important;
        padding-left: 40px !important;
        order: 2;
      }
      
      .desktop-reverse .desktop-image {
        order: 1;
      }
      
      .mobile-menu-icon {
        display: none !important;
      }
      
      .mobile-menu {
        display: none !important;
      }
      
      .desktop-get-quote {
        display: inline-block !important;
      }
    }
  `;

  return (
    <>
      <style>{responsiveStyles}</style>
      <div style={{ fontFamily: 'Arial, sans-serif' }}>
        {/* Header */}
        <header style={{
          position: 'sticky',
          top: 0,
          backgroundColor: 'white',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          zIndex: 1000,
          padding: '10px 20px'
        }}>
          <div style={{
            maxWidth: '1200px',
            margin: '0 auto',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <img
                src="/my-logo.png"
                alt="Cheapest Car Recovery UK Logo"
                style={{ height: '40px', width: 'auto' }}
              />
              <div className="header-title" style={{
                fontSize: '20px',
                fontWeight: 'bold',
                color: '#333'
              }}>
                CHEAPEST CAR RECOVERY UK
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
              {/* Desktop Navigation */}
              <nav className="header-nav" style={{ display: 'flex', gap: '20px' }}>
                <a href="/" style={{
                  color: '#333',
                  textDecoration: 'none',
                  fontWeight: '500',
                  fontSize: '16px'
                }}>Home</a>
                <a href="/about-us" style={{
                  color: '#000000',
                  textDecoration: 'none',
                  fontWeight: 'bold',
                  fontSize: '16px'
                }}>About Us</a>
              </nav>

              {/* Mobile Menu Icon */}
              <button
                className="mobile-menu-icon"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                style={{
                  display: 'none',
                  background: 'none',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  padding: '8px'
                }}
              >
                {mobileMenuOpen ? '✕' : '☰'}
              </button>

              {/* Get Quote Button */}
              <a
                href="#quote-form"
                className="desktop-get-quote"
                style={{
                  backgroundColor: '#FFF222',
                  color: '#333',
                  padding: '10px 20px',
                  border: 'none',
                  borderRadius: '5px',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  textDecoration: 'none',
                  display: 'inline-block'
                }}
              >
                Get Quote
              </a>
            </div>
          </div>

          {/* Mobile Menu */}
          <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
            <nav style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <a
                href="/"
                onClick={() => setMobileMenuOpen(false)}
                style={{
                  color: '#333',
                  textDecoration: 'none',
                  fontWeight: '500',
                  fontSize: '18px',
                  padding: '10px 0',
                  borderBottom: '1px solid #eee'
                }}
              >
                Home
              </a>
              <a
                href="/about-us"
                onClick={() => setMobileMenuOpen(false)}
                style={{
                  color: '#000000',
                  textDecoration: 'none',
                  fontWeight: 'bold',
                  fontSize: '18px',
                  padding: '10px 0',
                  borderBottom: '1px solid #eee'
                }}
              >
                About Us
              </a>
              <a
                href="#quote-form"
                className="desktop-get-quote"
                style={{
                  backgroundColor: '#FFF222',
                  color: '#333',
                  padding: '10px 20px',
                  border: 'none',
                  borderRadius: '5px',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  textDecoration: 'none',
                  display: 'inline-block'
                }}
              >
                Get Quote
              </a>
            </nav>
          </div>
        </header>

        {/* Hero Section */}
        <section className="section-padding" style={{
          background: 'linear-gradient(135deg, #FFF222 0%, #FFD700 100%)',
          padding: '60px 20px',
          minHeight: '600px',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 2 }}>
            <div className="hero-content desktop-flex" style={{ display: 'flex', alignItems: 'center', width: '100%', gap: '40px' }}>
              <div className="hero-text desktop-text" style={{ flex: 1 }}>
                <div className="hero-subtitle" style={{
                  fontSize: '16px',
                  fontWeight: 'bold',
                  color: '#333',
                  marginBottom: '15px',
                  textTransform: 'uppercase',
                  letterSpacing: '2px'
                }}>
                  PROFESSIONAL RECOVERY SERVICES
                </div>
                <h1
                  className="hero-title large-section-title"
                  style={{
                    fontSize: '52px',
                    fontWeight: '900',
                    marginBottom: '25px',
                    lineHeight: '1.1',
                    color: '#000000'
                  }}
                >
                  About Our Recovery Excellence
                </h1>

                <p className="large-section-text" style={{
                  fontSize: '20px',
                  color: '#333',
                  marginBottom: '35px',
                  lineHeight: '1.7',
                  fontWeight: '500'
                }}>
                  Your <strong>trusted road partner</strong> for 24/7 car breakdown assistance, towing services,
                  emergency roadside assistance, and motorway recovery serving customers across
                  every corner of the United Kingdom.
                </p>
                <div className="hero-buttons mobile-cta-flex" style={{ display: 'flex', gap: '20px', alignItems: 'center', flexWrap: 'wrap' }}>
                  <div className="hero-buttons-mobile" style={{
                    backgroundColor: '#333',
                    color: 'white',
                    padding: '18px 35px',
                    borderRadius: '50px',
                    fontSize: '18px',
                    fontWeight: 'bold',
                    border: 'none',
                    boxShadow: '0 8px 25px rgba(0,0,0,0.2)'
                  }}>
                    ⚡ 24/7 Emergency Service
                  </div>
                  <div style={{
                    fontSize: '16px',
                    color: '#333',
                    fontWeight: 'bold'
                  }}>
                    🏆 UK's Most Trusted
                  </div>
                </div>
              </div>
              <div className="hero-image desktop-image section-image" style={{ flex: 1, position: 'relative' }}>
                <img
                  src="https://images.unsplash.com/photo-1673187139211-1e7ec3dd60ec?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                  alt="Professional Car Recovery Team in Action"
                  style={{
                    width: '100%',
                    height: '400px',
                    objectFit: 'cover',
                    borderRadius: '20px',
                    boxShadow: '0 25px 50px rgba(0,0,0,0.3)'
                  }}
                />
                <div style={{
                  position: 'absolute',
                  bottom: '25px',
                  left: '25px',
                  background: 'rgba(0,0,0,0.9)',
                  color: 'white',
                  padding: '15px 25px',
                  borderRadius: '15px',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  backdropFilter: 'blur(10px)',
                  zIndex: 2
                }}>
                  Professional Recovery Team
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Mission Section */}
        <section className="section-padding" style={{
          padding: '80px 20px',
          backgroundColor: 'white'
        }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <div className="section-flex desktop-flex" style={{ display: 'flex', alignItems: 'center', gap: '50px' }}>
              <div className="section-image desktop-image">
                <div className="section-image" style={{ position: 'relative' }}>
                  <img
                    src="https://i.pinimg.com/736x/ca/dd/d8/caddd8fba45b8a8d4c440ce6425514da.jpg"
                    alt="Professional Car Recovery Tow Truck in Action"
                    style={{
                      width: '100%',
                      height: '450px',
                      objectFit: 'cover',
                      borderRadius: '20px',
                      boxShadow: '0 20px 40px rgba(0,0,0,0.15)'
                    }}
                  />
                  <div style={{
                    position: 'absolute',
                    top: '25px',
                    right: '25px',
                    background: 'rgba(255,242,34,0.95)',
                    color: '#333',
                    padding: '12px 20px',
                    borderRadius: '50px',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    zIndex: 2
                  }}>
                    ⚡ 24/7 Service
                  </div>
                </div>
              </div>
              <div className="section-text desktop-text" style={{ flex: 1 }}>
                <div style={{
                  fontSize: '16px',
                  fontWeight: 'bold',
                  color: '#000000',
                  marginBottom: '15px',
                  textTransform: 'uppercase',
                  letterSpacing: '2px'
                }}>
                  🎯 OUR MISSION
                </div>
                <h2 className="large-section-title" style={{
                  fontSize: '42px',
                  marginBottom: '25px',
                  color: '#333',
                  fontWeight: 'bold',
                  lineHeight: '1.2'
                }}>
                  Your Road to Recovery Starts Here
                </h2>
                <p className="large-section-text" style={{
                  fontSize: '20px',
                  lineHeight: '1.7',
                  color: '#666',
                  marginBottom: '25px'
                }}>
                  Whether you're stuck on the <strong style={{ color: '#333' }}>M1 in London</strong>, the <strong style={{ color: '#333' }}>M6 near Birmingham</strong>, the <strong style={{ color: '#333' }}>M25 ring</strong>,
                  or the remote <strong style={{ color: '#333' }}>A82 through the Scottish Highlands</strong>, our mission is simple:
                  <strong style={{ color: '#000000' }}> to get you back on the road quickly, safely, and affordably.</strong>
                </p>
                <p className="large-section-text" style={{
                  fontSize: '18px',
                  lineHeight: '1.7',
                  color: '#666',
                  marginBottom: '30px'
                }}>
                  With <strong style={{ color: '#333' }}>years of hands-on experience</strong> in the field, we understand that car troubles
                  can strike anytime, anywhere. That's why our professional team offers around-the-clock
                  vehicle recovery, fuel delivery for empty tanks, emergency jumpstarts for dead batteries,
                  tyre change assistance, and accident recovery services.
                </p>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(2, 1fr)',
                  gap: '15px',
                  marginTop: '30px'
                }}>
                  <div style={{
                    backgroundColor: '#f8f9fa',
                    padding: '15px',
                    borderRadius: '10px',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '24px', marginBottom: '5px' }}>🚗</div>
                    <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#333' }}>Fast Response</div>
                  </div>
                  <div style={{
                    backgroundColor: '#f8f9fa',
                    padding: '15px',
                    borderRadius: '10px',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '24px', marginBottom: '5px' }}>💰</div>
                    <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#333' }}>Best Prices</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Coverage Areas Section */}
        <section className="section-padding" style={{
          padding: '80px 20px',
          background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
          position: 'relative'
        }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 2 }}>
            <div style={{ textAlign: 'center', marginBottom: '60px' }}>
              <div style={{
                fontSize: '16px',
                fontWeight: 'bold',
                color: '#000000',
                marginBottom: '15px',
                textTransform: 'uppercase',
                letterSpacing: '2px'
              }}>
                🌍 NATIONWIDE COVERAGE
              </div>
              <h2 className="section-title large-section-title" style={{
                fontSize: '42px',
                marginBottom: '25px',
                color: '#333',
                fontWeight: '900'
              }}>
                UK-Wide Recovery Network
              </h2>
              <p className="large-section-text" style={{
                fontSize: '20px',
                marginBottom: '50px',
                color: '#666',
                maxWidth: '650px',
                margin: '0 auto 50px auto',
                lineHeight: '1.6'
              }}>
                From bustling city centers to remote highlands - we cover every corner of the UK with lightning-fast response times
              </p>
            </div>
            <div className="coverage-grid" style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '25px'
            }}>
              <div className="hover-lift" style={{
                background: 'linear-gradient(135deg, white 0%, #f8f9fa 100%)',
                padding: '40px 30px',
                borderRadius: '20px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                border: '2px solid transparent',
                backgroundClip: 'padding-box',
                position: 'relative',
                overflow: 'hidden'
              }}>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  width: '100px',
                  height: '100px',
                  background: 'linear-gradient(45deg, #FFF222, transparent)',
                  borderRadius: '0 20px 0 100px',
                  opacity: 0.1
                }}></div>
                <div style={{
                  width: '80px',
                  height: '80px',
                  background: 'linear-gradient(135deg, #FFF222 0%, #FFD700 100%)',
                  borderRadius: '20px',
                  margin: '0 auto 25px auto',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '30px',
                  boxShadow: '0 8px 20px rgba(255,242,34,0.3)',
                  position: 'relative',
                  zIndex: 2
                }}>
                  🏴󠁧󠁢󠁥󠁮󠁧󠁿
                </div>
                <h3 style={{ fontSize: '24px', marginBottom: '20px', color: '#333', textAlign: 'center', fontWeight: 'bold' }}>
                  England
                </h3>
                <div style={{
                  backgroundColor: '#f8f9fa',
                  padding: '20px',
                  borderRadius: '15px',
                  marginBottom: '15px'
                }}>
                  <p style={{ fontSize: '14px', color: '#666', lineHeight: '1.8', margin: 0 }}>
                    <strong style={{ color: '#333' }}>Motorways:</strong> M1, M4, M5, M6, M40, M60, M62<br />
                    <strong style={{ color: '#333' }}>Major Cities:</strong> London, Manchester, Birmingham, Liverpool, Leeds, Sheffield, Bristol, and more
                  </p>
                </div>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px',
                  fontSize: '15px',
                  color: '#000000',
                  fontWeight: 'bold'
                }}>
                  ⚡ Rapid Response Available
                </div>
              </div>
              <div className="hover-lift" style={{
                background: 'linear-gradient(135deg, white 0%, #f8f9fa 100%)',
                padding: '40px 30px',
                borderRadius: '20px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                border: '2px solid transparent',
                backgroundClip: 'padding-box',
                position: 'relative',
                overflow: 'hidden'
              }}>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  width: '100px',
                  height: '100px',
                  background: 'linear-gradient(45deg, #FFF222, transparent)',
                  borderRadius: '0 20px 0 100px',
                  opacity: 0.1
                }}></div>
                <div style={{
                  width: '80px',
                  height: '80px',
                  background: 'linear-gradient(135deg, #FFF222 0%, #FFD700 100%)',
                  borderRadius: '20px',
                  margin: '0 auto 25px auto',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '30px',
                  boxShadow: '0 8px 20px rgba(255,242,34,0.3)',
                  position: 'relative',
                  zIndex: 2
                }}>
                  🏴󠁧󠁢󠁳󠁣󠁴󠁿
                </div>
                <h3 style={{ fontSize: '24px', marginBottom: '20px', color: '#333', textAlign: 'center', fontWeight: 'bold' }}>
                  Scotland
                </h3>
                <div style={{
                  backgroundColor: '#f8f9fa',
                  padding: '20px',
                  borderRadius: '15px',
                  marginBottom: '15px'
                }}>
                  <p style={{ fontSize: '14px', color: '#666', lineHeight: '1.8', margin: 0 }}>
                    <strong style={{ color: '#333' }}>Motorways:</strong> M8, M9, M90, A9<br />
                    <strong style={{ color: '#333' }}>Areas:</strong> Glasgow to Edinburgh, Dundee, and the Scottish Highlands
                  </p>
                </div>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px',
                  fontSize: '15px',
                  color: '#000000',
                  fontWeight: 'bold'
                }}>
                  🏔️ Highland Specialists
                </div>
              </div>
              <div className="hover-lift" style={{
                background: 'linear-gradient(135deg, white 0%, #f8f9fa 100%)',
                padding: '40px 30px',
                borderRadius: '20px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                border: '2px solid transparent',
                backgroundClip: 'padding-box',
                position: 'relative',
                overflow: 'hidden'
              }}>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  width: '100px',
                  height: '100px',
                  background: 'linear-gradient(45deg, #FFF222, transparent)',
                  borderRadius: '0 20px 0 100px',
                  opacity: 0.1
                }}></div>
                <div style={{
                  width: '80px',
                  height: '80px',
                  background: 'linear-gradient(135deg, #FFF222 0%, #FFD700 100%)',
                  borderRadius: '20px',
                  margin: '0 auto 25px auto',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '30px',
                  boxShadow: '0 8px 20px rgba(255,242,34,0.3)',
                  position: 'relative',
                  zIndex: 2
                }}>
                  🏴󠁧󠁢󠁷󠁬󠁳󠁿
                </div>
                <h3 style={{ fontSize: '24px', marginBottom: '20px', color: '#333', textAlign: 'center', fontWeight: 'bold' }}>
                  Wales
                </h3>
                <div style={{
                  backgroundColor: '#f8f9fa',
                  padding: '20px',
                  borderRadius: '15px',
                  marginBottom: '15px'
                }}>
                  <p style={{ fontSize: '14px', color: '#666', lineHeight: '1.8', margin: 0 }}>
                    <strong style={{ color: '#333' }}>Motorways:</strong> M4, A470<br />
                    <strong style={{ color: '#333' }}>Areas:</strong> Cardiff, Swansea, and Newport
                  </p>
                </div>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px',
                  fontSize: '15px',
                  color: '#000000',
                  fontWeight: 'bold'
                }}>
                  🐉 Welsh Dragon Support
                </div>
              </div>
              <div className="hover-lift" style={{
                background: 'linear-gradient(135deg, white 0%, #f8f9fa 100%)',
                padding: '40px 30px',
                borderRadius: '20px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                border: '2px solid transparent',
                backgroundClip: 'padding-box',
                position: 'relative',
                overflow: 'hidden'
              }}>
                <div style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  width: '100px',
                  height: '100px',
                  background: 'linear-gradient(45deg, #FFF222, transparent)',
                  borderRadius: '0 20px 0 100px',
                  opacity: 0.1
                }}></div>
                <div style={{
                  width: '80px',
                  height: '80px',
                  background: 'linear-gradient(135deg, #FFF222 0%, #FFD700 100%)',
                  borderRadius: '20px',
                  margin: '0 auto 25px auto',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '30px',
                  boxShadow: '0 8px 20px rgba(255,242,34,0.3)',
                  position: 'relative',
                  zIndex: 2
                }}>
                  ☘️
                </div>
                <h3 style={{ fontSize: '24px', marginBottom: '20px', color: '#333', textAlign: 'center', fontWeight: 'bold' }}>
                  Northern Ireland
                </h3>
                <div style={{
                  backgroundColor: '#f8f9fa',
                  padding: '20px',
                  borderRadius: '15px',
                  marginBottom: '15px'
                }}>
                  <p style={{ fontSize: '14px', color: '#666', lineHeight: '1.8', margin: 0 }}>
                    <strong style={{ color: '#333' }}>Motorways:</strong> M1, M2, A1<br />
                    <strong style={{ color: '#333' }}>Areas:</strong> Belfast, Derry, and beyond
                  </p>
                </div>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px',
                  fontSize: '15px',
                  color: '#000000',
                  fontWeight: 'bold'
                }}>
                  ☘️ Emerald Isle Coverage
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Our Values Section */}
        <section className="section-padding" style={{
          padding: '80px 20px',
          backgroundColor: 'white'
        }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <div className="section-flex desktop-flex desktop-reverse" style={{ display: 'flex', alignItems: 'center', gap: '50px' }}>
              <div className="section-text desktop-text" style={{ flex: 1 }}>
                <div style={{
                  fontSize: '16px',
                  fontWeight: 'bold',
                  color: '#000000',
                  marginBottom: '15px',
                  textTransform: 'uppercase',
                  letterSpacing: '2px'
                }}>
                  💎 OUR CORE VALUES
                </div>
                <h2 className="large-section-title" style={{
                  fontSize: '42px',
                  marginBottom: '25px',
                  color: '#333',
                  fontWeight: 'bold',
                  lineHeight: '1.2'
                }}>
                  Quality Without Compromise
                </h2>
                <p className="large-section-text" style={{
                  fontSize: '20px',
                  lineHeight: '1.7',
                  color: '#666',
                  marginBottom: '25px'
                }}>
                  No matter where your car breaks down, we're committed to providing
                  <strong style={{ color: '#000000' }}> cheap car recovery services without compromising on quality or reliability.</strong>
                </p>
                <p className="large-section-text" style={{
                  fontSize: '18px',
                  lineHeight: '1.7',
                  color: '#666',
                  marginBottom: '25px'
                }}>
                  We believe in <strong style={{ color: '#333' }}>transparent pricing</strong>, <strong style={{ color: '#333' }}>friendly customer service</strong>, and professional
                  recovery solutions for all vehicle types: cars, vans, motorcycles, and light
                  commercial vehicles.
                </p>
                <p className="large-section-text" style={{
                  fontSize: '18px',
                  lineHeight: '1.7',
                  color: '#666',
                  marginBottom: '30px'
                }}>
                  Whether you're a <strong style={{ color: '#333' }}>daily commuter</strong>, a <strong style={{ color: '#333' }}>weekend traveler</strong>, or a <strong style={{ color: '#333' }}>business fleet manager</strong>,
                  we've got you covered.
                </p>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(3, 1fr)',
                  gap: '15px',
                  marginTop: '30px'
                }} className="mobile-features">
                  <div style={{
                    backgroundColor: '#f8f9fa',
                    padding: '15px',
                    borderRadius: '10px',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '24px', marginBottom: '5px' }}>💯</div>
                    <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#333' }}>Transparent</div>
                  </div>
                  <div style={{
                    backgroundColor: '#f8f9fa',
                    padding: '15px',
                    borderRadius: '10px',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '24px', marginBottom: '5px' }}>🚀</div>
                    <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#333' }}>Professional</div>
                  </div>
                  <div style={{
                    backgroundColor: '#f8f9fa',
                    padding: '15px',
                    borderRadius: '10px',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '24px', marginBottom: '5px' }}>🤝</div>
                    <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#333' }}>Reliable</div>
                  </div>
                </div>
              </div>
              <div className="section-image desktop-image">
                <div className="section-image" style={{ position: 'relative' }}>
                  <img
                    src="https://i.pinimg.com/736x/a2/74/31/a2743134e61972da711a8615fb74325a.jpg"
                    alt="Professional Roadside Assistance Mechanic at Work"
                    style={{
                      width: '100%',
                      height: '450px',
                      objectFit: 'cover',
                      borderRadius: '20px',
                      boxShadow: '0 20px 40px rgba(0,0,0,0.15)'
                    }}
                  />
                  <div style={{
                    position: 'absolute',
                    bottom: '25px',
                    left: '25px',
                    background: 'rgba(255,242,34,0.95)',
                    color: '#333',
                    padding: '12px 20px',
                    borderRadius: '50px',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    zIndex: 2
                  }}>
                    🔧 Expert Technicians
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Customer Promise Section */}
        <section style={{
          padding: '60px 20px',
          backgroundColor: '#f8f9fa'
        }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <h2 className="section-title" style={{
              fontSize: '36px',
              textAlign: 'center',
              marginBottom: '20px',
              color: '#333'
            }}>
              Our Promise to You
            </h2>
            <div className="values-grid" style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '30px',
              marginTop: '40px'
            }}>
              <div style={{
                backgroundColor: 'white',
                padding: '30px',
                borderRadius: '10px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                textAlign: 'center'
              }}>
                <div style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: '#FFF222',
                  borderRadius: '50%',
                  margin: '0 auto 20px auto',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '24px'
                }}>
                  💯
                </div>
                <h3 style={{ fontSize: '20px', marginBottom: '15px', color: '#333' }}>
                  Transparent Pricing
                </h3>
                <p style={{ fontSize: '14px', color: '#666', lineHeight: '1.6' }}>
                  No hidden fees or surprise charges. We provide upfront, honest pricing
                  for all our recovery services across the UK.
                </p>
              </div>
              <div style={{
                backgroundColor: 'white',
                padding: '30px',
                borderRadius: '10px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                textAlign: 'center'
              }}>
                <div style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: '#FFF222',
                  borderRadius: '50%',
                  margin: '0 auto 20px auto',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '24px'
                }}>
                  😊
                </div>
                <h3 style={{ fontSize: '20px', marginBottom: '15px', color: '#333' }}>
                  Friendly Service
                </h3>
                <p style={{ fontSize: '14px', color: '#666', lineHeight: '1.6' }}>
                  Our professional team treats every customer with respect and courtesy,
                  making your stressful situation a little easier.
                </p>
              </div>
              <div style={{
                backgroundColor: 'white',
                padding: '30px',
                borderRadius: '10px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                textAlign: 'center'
              }}>
                <div style={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: '#FFF222',
                  borderRadius: '50%',
                  margin: '0 auto 20px auto',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '24px'
                }}>
                  🏆
                </div>
                <h3 style={{ fontSize: '20px', marginBottom: '15px', color: '#333' }}>
                  Customer Satisfaction
                </h3>
                <p style={{ fontSize: '14px', color: '#666', lineHeight: '1.6' }}>
                  Peace of mind comes standard and customer satisfaction is our top priority.
                  We're not happy until you're back on the road.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Final CTA Section */}
        <section className="section-padding" style={{
          padding: '80px 20px',
          background: 'linear-gradient(135deg, #333 0%, #1a1a1a 100%)',
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Background decoration */}
          <div style={{
            position: 'absolute',
            top: '-50px',
            left: '-50px',
            width: '200px',
            height: '200px',
            background: 'linear-gradient(45deg, #FFF222, transparent)',
            borderRadius: '50%',
            opacity: 0.1
          }}></div>
          <div style={{
            position: 'absolute',
            bottom: '-100px',
            right: '-100px',
            width: '300px',
            height: '300px',
            background: 'linear-gradient(45deg, #FFF222, transparent)',
            borderRadius: '30px',
            transform: 'rotate(45deg)',
            opacity: 0.05
          }}></div>

          <div style={{ maxWidth: '900px', margin: '0 auto', position: 'relative', zIndex: 2 }}>
            <div>
              <div style={{
                fontSize: '16px',
                fontWeight: 'bold',
                color: '#FFF222',
                marginBottom: '20px',
                textTransform: 'uppercase',
                letterSpacing: '3px'
              }}>
                🏆 CHOOSE THE BEST
              </div>
              <h2 className="large-section-title" style={{
                fontSize: '48px',
                marginBottom: '30px',
                color: 'white',
                fontWeight: '900',
                textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                lineHeight: '1.2'
              }}>
                Ready for <span className="gradient-text" style={{
                  background: 'linear-gradient(45deg, #FFF222, #FFD700)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent'
                }}>Ultimate Recovery</span>?
              </h2>
              <p className="large-section-text" style={{
                fontSize: '22px',
                marginBottom: '45px',
                color: '#ccc',
                lineHeight: '1.6',
                fontWeight: '300',
                maxWidth: '750px',
                margin: '0 auto 45px auto'
              }}>
                Where <strong style={{ color: '#FFF222' }}>peace of mind</strong> comes standard and customer satisfaction is our top priority.
                Call us 24/7 and let us take the stress out of your journey.
              </p>

              <div className="mobile-cta-flex" style={{ display: 'flex', gap: '25px', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '50px' }}>
                <a
                  href="/#quote-form"
                  className="hover-lift hero-buttons-mobile"
                  style={{
                    background: 'linear-gradient(135deg, #FFF222 0%, #FFD700 100%)',
                    color: '#333',
                    padding: '22px 45px',
                    border: 'none',
                    borderRadius: '50px',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    textDecoration: 'none',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '12px',
                    boxShadow: '0 15px 35px rgba(255,242,34,0.3)',
                    transition: 'all 0.3s ease'
                  }}
                >
                  🚗 Get Instant Quote
                </a>
                <a
                  href="tel:+447432387241"
                  className="hover-lift hero-buttons-mobile"
                  style={{
                    backgroundColor: 'transparent',
                    color: 'white',
                    padding: '22px 45px',
                    border: '3px solid #FFF222',
                    borderRadius: '50px',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    textDecoration: 'none',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '12px',
                    transition: 'all 0.3s ease'
                  }}
                >
                  📞 Call Emergency Line
                </a>
              </div>

              <div className="mobile-features" style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(4, 1fr)',
                gap: '30px',
                justifyContent: 'center'
              }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '28px', color: '#FFF222', marginBottom: '8px' }}>⚡</div>
                  <div style={{ fontSize: '14px', color: '#ccc', fontWeight: 'bold' }}>Lightning Fast</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '28px', color: '#FFF222', marginBottom: '8px' }}>🏆</div>
                  <div style={{ fontSize: '14px', color: '#ccc', fontWeight: 'bold' }}>Award Winning</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '28px', color: '#FFF222', marginBottom: '8px' }}>💯</div>
                  <div style={{ fontSize: '14px', color: '#ccc', fontWeight: 'bold' }}>100% Guaranteed</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '28px', color: '#FFF222', marginBottom: '8px' }}>🇬🇧</div>
                  <div style={{ fontSize: '14px', color: '#ccc', fontWeight: 'bold' }}>UK Wide Coverage</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer style={{
          backgroundColor: '#333',
          color: 'white',
          padding: '40px 20px',
          textAlign: 'center'
        }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '15px', marginBottom: '20px' }}>
              <img
                src="/my-logo.png"
                alt="Cheapest Car Recovery UK Logo"
                style={{ height: '50px', width: 'auto' }}
              />
              <h3 style={{ fontSize: '24px', margin: 0 }}>
                Cheapest Car Recovery UK - Contact Us
              </h3>
            </div>
            <div style={{ fontSize: '18px', lineHeight: '2', marginBottom: '20px' }}>
              <div>📧 admin@cheapestcarrecovery.uk</div>
              <div>📞 +44 7432 387241</div>
              <div>📍 Serving the UK</div>
            </div>
            <p style={{ fontSize: '14px', color: '#ccc', marginTop: '20px' }}>
              © 2024 Cheapest Car Recovery UK. Professional vehicle recovery services across the UK.
              Available 24/7 for emergency breakdown recovery.
            </p>
          </div>
        </footer>
      </div>
    </>
  );
};

export default AboutUs; 